import { createAsyncThunk } from "@reduxjs/toolkit"
import { baseURL, requestUrl } from "../../../Utils/baseUrls"
import { AxiosResponse } from "axios"
import { APIResponse, FORMTOASTERRID, suportRequestTy } from "../../../Utils/Const"
import Toast from "../../../Components/ErrorBoundry/Toast"
import { SupportByIdDetail, SupportSubObjTy, SupportTicketParams } from "./types"

export const getStateDiscom = createAsyncThunk<any, any, {}>("statename/get", async (body, { rejectWithValue }) => {
    try {
        const stateName = body.toLowerCase().trim();
        const tariffState = stateName === "دبي" ? "dubai" : stateName;
        const { data }: AxiosResponse<APIResponse<any>> =
            await baseURL.get(`${requestUrl.discom}/${tariffState}`);
        if (data.code !== "200") {
            return rejectWithValue(data.message)
        }
        return data.responseData
    } catch (err: any) {
        return rejectWithValue([]);
    };
})
export const getTerrifData = createAsyncThunk<any, string>("tariff", async (providerid) => {
    const res = await baseURL.get(`${requestUrl.consumercategory}/${providerid}`)
    if (res.data.code === "200") {
        return res.data.responseData
    } else {
        return [];
    }
},
    {
        // skip the API call when providerid is missing (avoids /consumerslist/null 400)
        condition: (providerid) => !!providerid && providerid !== "null" && providerid !== "undefined"
    }
)


export const sendSupportRequest = async (requestBody: suportRequestTy) => {
    try {
        const formData = new FormData();
        formData.append("SubjectId", requestBody.subjectid ?? "");
        formData.append("Message", requestBody.message ?? "");

        // Attach file(s) if present
        if (requestBody.files) {
            if (Array.isArray(requestBody.files)) {
                requestBody.files.forEach((file: File) => {
                    formData.append("files", file);
                });
            } else {
                formData.append("files", requestBody.files);
            }
        }

        const response = await baseURL.post(`${requestUrl.createSupport}`, formData, { headers: { "Content-Type": "multipart/form-data" } });

        if (response?.data && response?.data.ticketCode) {
            return response
        }
    } catch (err: any) {
        Toast({
            messageText: "Something went wrong",
            messageType: "E",
            toastId: FORMTOASTERRID,
            autoClose: 1000,
        });
    }
};


// export const getSupportSubjList = createAsyncThunk<SupportSubObjTy[]>("subjectList/get", async () => {
//     try {
//         const res: AxiosResponse<APIResponse<SupportSubObjTy[]>> = await baseURL.get(`${requestUrl.SupportSubjList}`);
//         if (res.data.code !== "200") {
//             return [];
//         } else {
//             return res.data.responseData;
//         }
//     } catch (err: any) {
//         return [];
//     }
// })

export const getSupportSubjListCon = createAsyncThunk<SupportSubObjTy[]>("subjectList/get", async () => {
    try {
        const res: AxiosResponse<APIResponse<SupportSubObjTy[]>> = await baseURL.get(`${requestUrl.SupportSubjListCon}/consumer`);
        if (res.data.code !== "200") {
            return [];
        } else {
            return res.data.responseData;
        }
    } catch (err: any) {
        return [];
    }
}
)

export const getSupportTickets = async (params: SupportTicketParams) => {
    try {
        const { data } = await baseURL.get(requestUrl.getSupportTickets, { params });
        if (data && data.code === "200") {
            return data.responseData;
        }
        return null;
    } catch (err: any) {
        Toast({ messageText: "Failed to fetch tickets", messageType: "E", toastId: "ticketFetchErr", autoClose: 1000 });
        return null;
    }
};

export const submitSupportFeedback = async (supportid: string, body: { rating?: number; message?: string }) => {
    try {
        const { data } = await baseURL.post(`${requestUrl.submitSupportFeedback}/${supportid}/feedback`, body);
        if (data && data.code === "200") {
            return data.code;
        }
        return null;
    } catch (err: any) {
        Toast({ messageText: "Failed to submit feedback", messageType: "E", toastId: "feedbackErr", autoClose: 1000 });
        return null;
    }
};

/** Saves the logged-in user's 1-5 rating of pvNXT (the user comes from the token). Returns true when saved; shows a toast otherwise. */
export const submitPvnxtRating = async (rating: number): Promise<boolean> => {
    try {
        const { data } = await baseURL.patch(requestUrl.pvnxtRating, { rating_to_pvnxt:rating });
        // The response shape isn't documented: accept the usual wrapper with code "200" or a plain 2xx body
        if (!data?.code || data.code === "200") {
            return true;
        }
        Toast({ messageText: data?.message || "Failed to save your feedback", messageType: "E", toastId: "platformRatingErr" });
        return false;
    } catch (err: any) {
        Toast({ messageText: err?.response?.data?.message || "Failed to save your feedback. Please try again.", messageType: "E", toastId: "platformRatingErr" });
        return false;
    }
};

export const getSupportById = async (supportid: string): Promise<SupportByIdDetail | null> => {
    try {
        const { data } = await baseURL.get(`${requestUrl.getChatbySupportid}/${supportid}`);
        if (data?.code === "200") {
            return data.responseData as SupportByIdDetail;
        }
        return null;
    } catch (err) {
        Toast({ messageText: "Failed to load ticket details", messageType: "E", toastId: "ticketDetailErr", autoClose: 1500 });
        return null;
    }
};